import { Playground } from 'docz';
import Frame from "../../../../../src/components/Frame.tsx";
import ScatterPlot from "../../../../../src/components/ScatterPlot";
import cars from "../../../../../src/data/cars";
import * as React from 'react';
export default {
  Playground,
  Frame,
  ScatterPlot,
  cars,
  React
};